import { api } from '@/lib/api';

export async function registerPushToken(token: string, platform: 'ios' | 'android'): Promise<void> {
  await api.post('/push-tokens', { token, platform });
}

export async function unregisterPushToken(token: string): Promise<void> {
  await api.delete(`/push-tokens/${encodeURIComponent(token)}`);
}
